import { getMessageAttachments } from '@/context/AskAiContext/helpers';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Link, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

const openAttachment = (file) => {
	const url = file.webUrl ?? file.url;
	if (!url) return;

	const openUrl = url.includes('?web=') ? url : `${url}?web=1`;
	window.open(openUrl, '_blank', 'noopener,noreferrer');
};

const UserMessageAttachments = ({ message }) => {
	const theme = useTheme();
	const attachments = getMessageAttachments(message);

	if (!attachments.length) return null;

	return (
		<Stack spacing={0.5} sx={{ mb: 0.75 }}>
			{attachments.map((file, index) => {
				const canOpen = Boolean(file.webUrl ?? file.url);

				return (
					<Stack
						key={file.id ?? `${file.name}-${index}`}
						direction='row'
						spacing={0.75}
						alignItems='center'
					>
						<AttachFileIcon
							sx={(theme) => ({ fontSize: 16, color: theme.palette.primary.main })}
						/>
						<Link
							component={canOpen ? 'button' : 'span'}
							underline='hover'
							variant='body2'
							color={canOpen ? theme.palette.primary.main : 'inherit'}
							onClick={canOpen ? () => openAttachment(file) : undefined}
							sx={{
								textAlign: 'left',
								cursor: canOpen ? 'pointer' : 'default',
								fontWeight: 500,
							}}
							noWrap
						>
							{file.name}
						</Link>
					</Stack>
				);
			})}
		</Stack>
	);
};

export default UserMessageAttachments;
